import { I18n } from "i18n-js";
import en from "./en";
import ja from "./ja";
import zh_cn from "./zh_cn";
import zh_tw from "./zh_tw";
import ja_kanji from "./ja_kanji";

export const I18nTranslations = {
  en: en,
  ja: ja,
  ja_kanji: ja_kanji,
  zh_cn: zh_cn,
  zh_tw: zh_tw,
};

const i18n = new I18n(I18nTranslations);
i18n.enableFallback = true;
i18n.locale = "ja";

export default i18n;
